
































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import NewPayAuthorityModal from './components/NewPayAuthorityModal.vue';
import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { SummaryPayAuthorityModel } from '@/models/payauthority';
import { PayAuthorityModel } from '@/models/payauthority';

import ListPayAuthority from './components/ListPayAuthority.vue';
import FilterBox from './components/FilterBox.vue';

import authService from '@/services/auth-services';
import payauthorityServices from '@/services/payauthority-services';
import commonService from '@/services/common-services';
@Component({
    components: {
        ListPayAuthority,
        FilterBox,
        Loading,
        Paging,
        'new-pay-authority': NewPayAuthorityModal
    }
})
export default class MainPayAuthority extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private summaryOrder: SummaryPayAuthorityModel = new SummaryPayAuthorityModel();
    private listPayAuthority: PayAuthorityModel[] = [];
    private isLoading = false;
    private isShowModal = false;
    private customerInfo: any = {};
    private newPayAuthority: any = {
        Amount: 0,
        NumberDetail: 0,
        Content: ''
    };

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

        get rate() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
        }

    private async created() {
        await this.getCustomersInfo();
        await this.getRate();
        this.loadData();
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      }
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        this.summaryOrder = new SummaryPayAuthorityModel();
        const result = await payauthorityServices.getList(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListPayAuthority: PayAuthorityModel[] = [];
            this.pageSettings.total = result.data.total;
            this.summaryOrder = {
                TotalStatusAll: result.data.summary.TotalStatusAll || 0,
                TotalStatus1: result.data.summary.TotalStatus1 || 0,
                TotalStatus2: result.data.summary.TotalStatus2 || 0,
                TotalStatus3: result.data.summary.TotalStatus3 || 0,
                TotalStatus4: result.data.summary.TotalStatus4 || 0,
                TotalStatus5: result.data.summary.TotalStatus5 || 0,
                TotalStatus6: result.data.summary.TotalStatus6 || 0
            };

            for (const item of result.data.data) {
                const payauthority = new PayAuthorityModel();
                payauthority.ID = item.ID;
                payauthority.Status = item.Status;
                payauthority.Amount = item.Amount;
                payauthority.ExchangeRate = item.ExchangeRate;
                payauthority.Fee = item.Fee;
                payauthority.FeeVND = item.FeeVND;
                payauthority.TotalAmount = item.TotalAmount;
                payauthority.Content = item.Content;
                payauthority.Dispute = item.Dispute;
                payauthority.Refund = item.Refund;
                payauthority.CreatedDate = item.CreatedDate;
                payauthority.statusDetail = DATA.payauthorityStatus.find(x => x.value === item.Status) || { value: 0, name: '', color: '#3b4354' };
                tmpListPayAuthority.push(payauthority);
            }
            this.listPayAuthority = tmpListPayAuthority;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.selectedStatus.value !== -1) {
            paramsFilter.filters.push({
                column: 'Status',
                value: this.filterProp.selectedStatus.value,
                condition: 'equal'
            });
        }

        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'Amount',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText,
                    condition: 'contain'
                });
        }

        return paramsFilter;
    }

    private createNewPayAuthority() {
        this.isShowModal = true;
    }
    private onCloseModal() {
        this.isShowModal = false;
    }

    private async onAcceptModal() {
        if (Number(this.newPayAuthority.Amount) <= 0) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Đơn ủy quyền phải có giá trị!' });
            return;
        }
        if (Number(this.newPayAuthority.NumberDetail) <= 0 || (Number(this.newPayAuthority.NumberDetail) * 10) % 10 != 0) {
            Vue.notify({ group: 'foo', type: 'error', title: 'Thông báo!', text: 'Số lệnh thanh toán phải có giá trị!' });
            return;
        }
        this.isShowModal = false;
        this.isLoading = true;
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            Status: 2,
            ExchangeRate: this.rate,
            Amount: Number(this.newPayAuthority.Amount),
            AmountVND: Number(this.newPayAuthority.Amount) * Number(this.rate),
            TotalAmount: Number(this.newPayAuthority.Amount) * Number(this.rate),
            Content: this.newPayAuthority.Content,
            NumberDetail: this.newPayAuthority.NumberDetail,
        };
        const result = await payauthorityServices.addDetail(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới yêu cầu thanh toán ủy quyền thành công!',
            });
            this.loadData();
            this.newPayAuthority = {
                Amount: 0,
                NumberDetail: 0,
                Content: ''
            };
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private onFilterChanged(data: any) {
        this.filterProp.selectedStatus = data.status;
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }

    private onChangePage(data: any) {
      this.pageSettings.pageIndex = data;
      this.loadData();
    }
}
